var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54161 2.15406L9.79561 9.41406C9.93161 9.55406 9.99961 9.71506 9.99961 9.89706C9.99802 10.0837 9.92502 10.2626 9.79561 10.3971L2.22061 17.7951C1.83728 18.1124 1.49661 18.1124 1.19861 17.7951C0.899943 17.4784 0.899943 17.1517 1.19861 16.8151L8.27861 9.89706L1.52461 3.13406C1.28728 2.79139 1.30928 2.47973 1.59061 2.19906C1.87194 1.91906 2.18894 1.90406 2.54161 2.15406ZM11.5416 2.15406L18.7956 9.41406C18.9316 9.55406 18.9996 9.71506 18.9996 9.89706C18.998 10.0837 18.925 10.2626 18.7956 10.3971L11.2206 17.7951C10.8373 18.1124 10.4966 18.1124 10.1986 17.7951C9.89928 17.4784 9.89928 17.1517 10.1986 16.8151L17.2786 9.89706L10.5246 3.13406C10.2879 2.79139 10.3099 2.47973 10.5906 2.19906C10.8719 1.91906 11.1889 1.90406 11.5416 2.15406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRightArrow);
export default __webpack_public_path__ + "static/media/doubleRightArrow.259ff12da0b7ea732ed1406496bbbd6c.svg";
export { ForwardRef as ReactComponent };